import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import 'vue3-carousel/dist/carousel.css'
import 'tocbot/dist/tocbot.css'
import VueGtag from 'vue-gtag'
import VueSocialSharing from 'vue-social-sharing'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
  .use(VueGtag, { config: { id: process.env.VUE_APP_GA_MEASUREMENT_ID } })
  .use(VueSocialSharing)
  .use(VueToast)
  .mount('#app')